import * as React from 'react';
import GoalsContainer from 'source/app/presentation/MainPanel/Goals/GoalsContainer';
import { FormTextArea } from 'source/app/presentation/Shared/Form/TextArea/FormTextArea';
import Glyphicon from 'source/app/presentation/Shared/Glyphicon/Glyphicon';
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Hyperlink from 'source/app/presentation/Shared/Link/Hyperlink';
import Data from 'source/app/services/Data';
import MotwLogicServer from 'source/app/services/External/LogicServer/MotwLogicServer';
import * as toastr from 'toastr';
import { IGoalsContainerState } from '../../IGoalsState';
import ClientDataProvider from 'source/app/services/External/ClientDataProvider/ClientDataProvider';

export function EditEnergyRankOrder({
	goalsContainer
}: {
	goalsContainer: GoalsContainer;
}) {
	const existingOrder = JSON.stringify(
		goalsContainer.state.Goals
			.filter((goal) => goal.energyrank !== null)
			.sort((a, b) => a.energyrank! - b.energyrank!)
			.map((goal) => goal.name)
	);
	const [ data, setData ] = React.useState(existingOrder);

	return (
		<div>
			<FormTextArea
				id="editEnergyRankOrder"
				label="Energy rank order"
				width="70%"
				value={data}
				onChange={(value) => setData(value)}
			/>
			<Hyperlink
				whenClicked={async () => {
					try {
						const validatedData = ProcessEnergyRankOrderInput(data);

						await ClientDataProvider.AddRecordAsync(`rpc/update_energy_rank`, {
							data: validatedData
						});

						Data.Load.Single.ByStateTarget<IGoalsContainerState>(
							'Goals'
						);
					} catch (e) {
						console.error(e);
						toastr.error(e);
					}
				}}
			>
				<Glyphicon icon={EGlyphicon.ok} />
			</Hyperlink>
		</div>
	);
}

function ProcessEnergyRankOrderInput(input: string) {
	const values: string[] = JSON.parse(input);
	return values;
}
